var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"navbar_icon-link navbar_language-selector",attrs:{"data-cover":"#lang-selector-cover"}},[_c('div',{staticClass:"ml-2 mr-n1 d-flex"},[_c('span',{staticClass:"text-theme-color"},[_c('span',{staticClass:"pr-1 no-pointers"},[_vm._v(_vm._s(_vm.lang.toUpperCase()))])])])])
}
var staticRenderFns = []

export { render, staticRenderFns }